var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M59,12.7v45.8h9.9V12.7c0-3.1,2.5-5.7,5.5-5.7s5.5,2.6,5.5,5.7v45.8h9.9V12.7c0-3.1,2.5-5.7,5.5-5.7 c3,0,5.5,2.6,5.5,5.7v45.8h14.4c3.2,0,5.7,2.4,5.7,5.5c0,3-2.6,5.5-5.7,5.5h-14.4v45.8c0,3.1-2.5,5.7-5.5,5.7c-3,0-5.5-2.6-5.5-5.7 V69.5h-9.9v45.8c0,3.1-2.5,5.7-5.5,5.7c-3,0-5.5-2.6-5.5-5.7V69.5H59v45.8c0,3.1-2.5,5.7-5.5,5.7c-3,0-5.5-2.6-5.5-5.7V69.5h-9.9 v45.8c0,3.1-2.5,5.7-5.5,5.7s-5.5-2.6-5.5-5.7V69.5H12.7C9.5,69.5,7,67,7,64c0-3,2.5-5.5,5.7-5.5h14.4V12.7c0-3.1,2.5-5.7,5.5-5.7 s5.5,2.6,5.5,5.7v45.8h10V12.7c0-3.1,2.5-5.7,5.5-5.7C56.6,7,59,9.6,59,12.7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUob);
export default __webpack_public_path__ + "static/media/uob.0a8a97d054c304090c3a55ddbd20e722.svg";
export { ForwardRef as ReactComponent };